import React, { FC, useCallback } from 'react';
import { makeStyles, MenuItem } from '@material-ui/core';
import { MergeField } from '@groove/ui/type';

interface MergeFieldMenuItemProps {
  mergeField: MergeField;
  onSelect: (mergeField: MergeField) => void;
}

const useStyles = makeStyles({
  item: {
    fontSize: 12,
    padding: 8,
    height: 32,
    boxSizing: 'border-box',
  },
});

const MergeFieldMenuItem: FC<MergeFieldMenuItemProps> = ({
  mergeField,
  onSelect,
}) => {
  const classes = useStyles();
  const handleClick = useCallback(() => {
    onSelect(mergeField);
  }, [mergeField, onSelect]);

  return (
    <MenuItem
      value={mergeField.name}
      data-testid={mergeField.name}
      onClick={handleClick}
      className={classes.item}
    >
      {mergeField.label}
    </MenuItem>
  );
};

export default MergeFieldMenuItem;
